import React from 'react'
import cv from "../Projects/Cv/ArindamCV.pdf"
import { Helmet } from 'react-helmet'
import "../CSS/Template/myCv.css"
export default function myCv() {
    return (
        <>
            <Helmet>
                <title>Code Arindam | My CV</title>
            </Helmet>
            <div id="mainCvPage">
                <h1 className='cvText'>Welcome To Code Arindam CV</h1>
                <iframe src={cv} type="pdf" title='Code Arindam CV'></iframe>
                <a className='cvDownBtn' href={cv} download>Click To Download</a>
            </div>
        </>
    )
}
